import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// import 'vuetify/dist/vuetify.min.css'
import VueOffline from 'vue-offline'
import VueClipboard from 'vue-clipboard2'
import Chat from 'vue-beautiful-chat'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-flash'
import VueYoutube from 'vue-youtube'
import { Table, Input } from 'buefy'
import vueCustomElement from 'vue-custom-element'
import 'deep-chat' // Importa o componente Deep Chat

// Habilita suporte a Custom Elements no Vue 2
Vue.use(vueCustomElement)

// Registra a tag <deep-chat> globalmente
Vue.customElement('deep-chat', 'deep-chat')

Vue.prototype.$eventHub = new Vue()
export const EventBus = new Vue()

// console.log = function(){}
Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueYoutube)
Vue.use(Chat)
Vue.use(VueOffline)
Vue.use(VueClipboard)
Vue.use(VueVideoPlayer)
Vue.use(Table)
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md'
})

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
